<template>
  <div class="sub-menu">
    <div class="sub-menu__title">
      Parlay:
    </div>
    <div class="sub-menu__options">
      <div v-for="(option, index) of options" :key="index" class="sub-menu__options__option">
        <div
          :class="{ active: selectedOptionIndex === index }"
          @click="
            selectedOptionIndex = index;
            onClickSelected(option);
          "
        >
          <div>
            <span>{{ option.name }}</span>
            <span> - {{ getRiskText(option.bet_risk) }}</span>
          </div>
          <div :style="getRiskBackgroundColor(index)"></div>
        </div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import { parlay2Games1, parlay2Games2, parlay3Games, parlay4Games } from '@/utils/analytics';
import { mapGetters } from 'vuex';
export default {
  name: 'ParlaySubMenu',
  props: {
    availableBets: {
      type: Array,
      default: () => [],
    },
    minParlayIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectedOptionIndex: 0,
    };
  },
  computed: {
    options() {
      return [...this.availableBets];
    },
    ...mapGetters('loginGeneral', ['getPremiumAccount', 'getIsGolstats']),
  },
  watch: {
    selectedOptionIndex: {
      immediate: true,
      handler(newValue) {
        this.$emit('select', newValue);
      },
    },
    minParlayIndex(newValue) {
      this.selectedOptionIndex = newValue;
    },
  },
  methods: {
    getRiskBackgroundColor(index) {
      let color = '';
      switch (index) {
        case 0:
          color = '#9ecb26';
          break;
        case 1:
          color = '#f1d021';
          break;
        case 2:
          color = '#f1d021';
          break;
        case 3:
          color = '#f17921';
          break;
        default:
          color = 'white';
      }
      return { 'background-color': color };
    },
    getRiskText(risk = 0) {
      let text = '';
      switch (risk) {
        case 1:
          text = 'Bajo';
          break;
        case 2:
          text = 'Medio';
          break;
        case 3:
          text = 'Alto';
          break;
        default:
          text = '';
      }
      return `${text} Riesgo`;
    },
    onClickSelected(option) {
      let parlayIds = {
        1: () =>
          parlay2Games1({
            is_premium: this.getPremiumAccount,
            golstats: this.getIsGolstats,
          }),
        2: () =>
          parlay2Games2({
            is_premium: this.getPremiumAccount,
            golstats: this.getIsGolstats,
          }),
        3: () =>
          parlay3Games({
            is_premium: this.getPremiumAccount,
            golstats: this.getIsGolstats,
          }),
        4: () =>
          parlay4Games({
            is_premium: this.getPremiumAccount,
            golstats: this.getIsGolstats,
          }),
      };
      parlayIds[option.parlay_id]();
    },
  },
};
</script>

<style scoped lang="scss">
.sub-menu {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  width: 100%;

  &__title {
    font-family: Heebo, sans-serif;
    font-size: 1.687em;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.04;
    letter-spacing: -0.54px;
    color: #313a42;
    margin-right: 1em;
  }

  &__options {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    border-radius: 12px;
    border: solid 1px black;
    width: 100%;

    &__option {
      height: 2.375em;
      display: flex;

      & > div {
        &:first-child {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0.15em;
          border-radius: 5px;
          cursor: pointer;

          &.active {
            background-color: #132839;

            & > div:first-child {
              color: white;
            }
          }

          & > div {
            &:first-child {
              font-family: Heebo, sans-serif;
              font-size: 1.125em;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: 1;
              letter-spacing: -0.36px;
              color: #132839;

              & > span {
                &:first-child {
                  font-family: Roboto-Bold, sans-serif;
                  font-weight: 500;
                }
                &:last-child {
                  display: none;
                }
              }
            }

            &:last-child {
              height: 0.875em;
              width: 0.875em;
              border-radius: 50%;
              margin-left: 0.625em;
            }
          }
        }
        &:last-child {
          border-left: dotted 1px black;
        }
      }

      &:first-child {
        & > div {
          &:first-child {
            border-radius: 10px 5px 5px 10px;
          }
        }
      }

      &:last-child {
        & > div {
          &:first-child {
            border-radius: 5px 10px 10px 5px;
          }

          &:last-child {
            border-left: unset;
          }
        }
      }
    }
  }

  @media screen and (max-width: 666px) {
    font-size: 0.8rem;
  }

  @media screen and (max-width: 525px) {
    font-size: 1rem;
    flex-direction: column;

    &__title {
      margin: 0 0 0.7em 0;
    }

    &__options {
      grid-template-columns: 1fr;
      border-radius: 14px;

      &__option {
        & > div {
          &:first-child {
            border: solid 1px #132839;
            border-radius: 12px;
            justify-content: space-between;
            padding: 0 0.75em 0 1.5em;

            & > div {
              &:first-child {
                font-weight: bold;

                & > span:last-child {
                  display: inline;
                  font-weight: 500;
                }
              }

              &:last-child {
                height: 0.875em;
                width: 0.875em;
                border-radius: 50%;
                margin-left: 0.625em;
              }
            }
          }
          &:last-child {
            border-left: unset;
          }
        }

        &:first-child {
          & > div {
            &:first-child {
              border-radius: 12px;
            }
          }
        }

        &:last-child {
          & > div {
            &:first-child {
              border-radius: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
